import Vue from "vue"
import * as Facebook from "fb-sdk-wrapper"

export default {
  data: function () {
    return {
      FB: undefined,
      fbIsInit: false,
    }
  },
  methods: {
    fbLoad: function (done, cancel) {
      Facebook.load()
        .then(() => {
          console.log("Loading !")
          Facebook.init({
            appId: Vue.config.devtools ? "384312898950821" : "1825835761051864",
            cookie: true,
            xfbml: true,
            version: "v3.2",
          })
          this.$set(this, "FB", Facebook)
          this.fbIsInit = true
          if (typeof done === "function") done()
        })
        .catch(() => {
          if (typeof cancel === "function")
            cancel(new Error(this.$t("errors.facebook.package_blocked")))
        })
    },
  },
}
